// libs/commons/src/lib/commons.ts

export const COUNTRIES = [
  {
    name: 'Andorra',
    nombre: 'Andorra ',
    iso: 'AD',
  },
  {
    name: 'United Arab Emirates',
    nombre: 'Emiratos Árabes Unidos ',
    iso: 'AE',
  },
  {
    name: 'Afghanistan',
    nombre: 'Afganistán ',
    iso: 'AF',
  },
  {
    name: 'Antigua and Barbuda',
    nombre: 'Antigua y Barbuda ',
    iso: 'AG',
  },
  {
    name: 'Anguilla',
    nombre: 'Anguila ',
    iso: 'AI',
  },
  {
    name: 'Albania',
    nombre: 'Albania ',
    iso: 'AL',
  },
  {
    name: 'Armenia',
    nombre: 'Armenia ',
    iso: 'AM',
  },
  {
    name: 'Netherlands Antilles',
    nombre: 'Antillas Holandesas ',
    iso: 'AN',
  },
  {
    name: 'Angola',
    nombre: 'Angola ',
    iso: 'AO',
  },
  {
    name: 'Antarctica',
    nombre: 'Antártida ',
    iso: 'AQ',
  },
  {
    name: 'Argentina',
    nombre: 'Argentina ',
    iso: 'AR',
  },
  {
    name: 'American Samoa',
    nombre: 'Samoa Americana ',
    iso: 'AS',
  },
  {
    name: 'Austria',
    nombre: 'Austria ',
    iso: 'AU',
  },
  {
    name: 'Australia',
    nombre: 'Australia ',
    iso: 'AS',
  },
  {
    name: 'Aruba',
    nombre: 'Aruba ',
    iso: 'AW',
  },
  {
    name: 'Azerbaijan',
    nombre: 'Azerbaiyán ',
    iso: 'AZ',
  },
  {
    name: 'Bosnia and Herzegovina',
    nombre: 'Bosnia y Herzegovina ',
    iso: 'BA',
  },
  {
    name: 'Barbados',
    nombre: 'Barbados ',
    iso: 'BB',
  },
  {
    name: 'Bangladesh',
    nombre: 'Bangladesh ',
    iso: 'BD',
  },
  {
    name: 'Belgium',
    nombre: 'Bélgica ',
    iso: 'BE',
  },
  {
    name: 'Burkina Faso',
    nombre: 'Burkina Faso ',
    iso: 'BF',
  },
  {
    name: 'Bahrain',
    nombre: 'Bahrein ',
    iso: 'BH',
  },
  {
    name: 'Burundi',
    nombre: 'Burundi ',
    iso: 'BI',
  },
  {
    name: 'Benin',
    nombre: 'Benin ',
    iso: 'BJ',
  },
  {
    name: 'Bermuda',
    nombre: 'Bermudas ',
    iso: 'BM',
  },
  {
    name: 'Bolivia',
    nombre: 'Bolivia ',
    iso: 'BO',
  },
  {
    name: 'Brazil',
    nombre: 'Brasil ',
    iso: 'BR',
  },
  {
    name: 'Bahamas',
    nombre: 'Bahamas ',
    iso: 'BS',
  },
  {
    name: 'Bhutan',
    nombre: 'Bután ',
    iso: 'BT',
  },
  {
    name: 'Bouvet Island',
    nombre: 'Isla Bouvet ',
    iso: 'BU',
  },
  {
    name: 'Bulgaria',
    nombre: 'Bulgaria ',
    iso: 'BV',
  },
  {
    name: 'Botswana',
    nombre: 'Botswana ',
    iso: 'BW',
  },
  {
    name: 'Brunei Darussalam',
    nombre: 'Brunei Darussalam ',
    iso: 'BX',
  },
  {
    name: 'Belarus',
    nombre: 'Bielorrusia ',
    iso: 'BY',
  },
  {
    name: 'Belize',
    nombre: 'Belice ',
    iso: 'BZ',
  },
  {
    name: 'Canada',
    nombre: 'Canadá ',
    iso: 'CA',
  },
  {
    name: 'Cocos (Keeling) Islands',
    nombre: 'Cocos (Keeling) ',
    iso: 'CC',
  },
  {
    name: 'Central African Republic',
    nombre: 'República Centroafricana ',
    iso: 'CF',
  },
  {
    name: 'Congo',
    nombre: 'Congo ',
    iso: 'CG',
  },
  {
    name: 'Switzerland',
    nombre: 'Suiza ',
    iso: 'CH',
  },
  {
    name: "Cote D'Ivoire (Ivory Coast)",
    nombre: "Cote D'Ivoire (Costa de Marfil) ",
    iso: 'CI',
  },
  {
    name: 'Cook Islands',
    nombre: 'Islas Cook ',
    iso: 'CK',
  },
  {
    name: 'Chile',
    nombre: 'Chile ',
    iso: 'CL',
  },
  {
    name: 'Cameroon',
    nombre: 'Camerún ',
    iso: 'CM',
  },
  {
    name: 'China',
    nombre: 'China ',
    iso: 'CN',
  },
  {
    name: 'Colombia',
    nombre: 'Colombia ',
    iso: 'CO',
  },
  {
    name: 'Costa Rica',
    nombre: 'Costa Rica ',
    iso: 'CR',
  },
  {
    name: 'Cuba',
    nombre: 'Cuba ',
    iso: 'CU',
  },
  {
    name: 'Cape Verde',
    nombre: 'Cabo Verde ',
    iso: 'CV',
  },
  {
    name: 'Christmas Island',
    nombre: 'Isla de Navidad ',
    iso: 'CX',
  },
  {
    name: 'Cyprus',
    nombre: 'Chipre ',
    iso: 'CY',
  },
  {
    name: 'Czech Republic',
    nombre: 'República Checa ',
    iso: 'CZ',
  },
  {
    name: 'Germany',
    nombre: 'Alemania ',
    iso: 'DE',
  },
  {
    name: 'Djibouti',
    nombre: 'Djibouti ',
    iso: 'DJ',
  },
  {
    name: 'Denmark',
    nombre: 'Dinamarca ',
    iso: 'DK',
  },
  {
    name: 'Dominica',
    nombre: 'Dominica ',
    iso: 'DM',
  },
  {
    name: 'Dominican Republic',
    nombre: 'República Dominicana ',
    iso: 'DO',
  },
  {
    name: 'Algeria',
    nombre: 'Argelia ',
    iso: 'DZ',
  },
  {
    name: 'Ecuador',
    nombre: 'Ecuador ',
    iso: 'EC',
  },
  {
    name: 'Estonia',
    nombre: 'Estonia ',
    iso: 'EE',
  },
  {
    name: 'Egypt',
    nombre: 'Egipto ',
    iso: 'EG',
  },
  {
    name: 'Western Sahara',
    nombre: 'Sáhara Occidental ',
    iso: 'EH',
  },
  {
    name: 'Eritrea',
    nombre: 'Eritrea ',
    iso: 'ER',
  },
  {
    name: 'Spain',
    nombre: 'España ',
    iso: 'ES',
  },
  {
    name: 'Ethiopia',
    nombre: 'Etiopía ',
    iso: 'ET',
  },
  {
    name: 'Finland',
    nombre: 'Finlandia ',
    iso: 'FI',
  },
  {
    name: 'Fiji',
    nombre: 'Fiji ',
    iso: 'FJ',
  },
  {
    name: 'Falkland Islands (Malvinas)',
    nombre: 'Islas Malvinas (Falkland) ',
    iso: 'FK',
  },
  {
    name: 'Micronesia',
    nombre: 'Micronesia ',
    iso: 'FM',
  },
  {
    name: 'Faroe Islands',
    nombre: 'Islas Feroe ',
    iso: 'FO',
  },
  {
    name: 'France',
    nombre: 'Francia ',
    iso: 'FR',
  },
  {
    name: 'Gabon',
    nombre: 'Gabón ',
    iso: 'GA',
  },
  {
    name: 'Great Britain (UK)',
    nombre: 'Gran Bretaña (Reino Unido) ',
    iso: 'GB',
  },
  {
    name: 'Grenada',
    nombre: 'Granada ',
    iso: 'GD',
  },
  {
    name: 'Georgia',
    nombre: 'Georgia ',
    iso: 'GE',
  },
  {
    name: 'French Guiana',
    nombre: 'Guayana Francesa',
    iso: 'GF',
  },
  {
    name: 'Ghana',
    nombre: 'Ghana ',
    iso: 'GH',
  },
  {
    name: 'Gibraltar',
    nombre: 'Gibraltar ',
    iso: 'GI',
  },
  {
    name: 'Greenland',
    nombre: 'Groenlandia ',
    iso: 'GL',
  },
  {
    name: 'Gambia',
    nombre: 'Gambia ',
    iso: 'GM',
  },
  {
    name: 'Guinea',
    nombre: 'Guinea ',
    iso: 'GN',
  },
  {
    name: 'Guadeloupe',
    nombre: 'Guadalupe ',
    iso: 'GP',
  },
  {
    name: 'Equatorial Guinea',
    nombre: 'Guinea Ecuatorial ',
    iso: 'GQ',
  },
  {
    name: 'Greece',
    nombre: 'Grecia ',
    iso: 'GR',
  },
  {
    name: 'South Georgia and South Sandwich Islands',
    nombre: 'Georgia del Sur y Islas Sandwich del Sur ',
    iso: 'GS',
  },
  {
    name: 'Guatemala',
    nombre: 'Guatemala ',
    iso: 'GT',
  },
  {
    name: 'Guam',
    nombre: 'Guam ',
    iso: 'GU',
  },
  {
    name: 'Guinea-Bissau',
    nombre: 'Guinea-Bissau ',
    iso: 'GW',
  },
  {
    name: 'Guyana',
    nombre: 'Guayana ',
    iso: 'GY',
  },
  {
    name: 'Hong Kong',
    nombre: 'Hong Kong ',
    iso: 'HK',
  },
  {
    name: 'Heard and McDonald Islands',
    nombre: 'Islas Heard y McDonald ',
    iso: 'HM',
  },
  {
    name: 'Honduras',
    nombre: 'Honduras ',
    iso: 'HN',
  },
  {
    name: 'Croatia and Hrvatska',
    nombre: 'Croacia',
    iso: 'HR',
  },
  {
    name: 'Haiti',
    nombre: 'Haití ',
    iso: 'HT',
  },
  {
    name: 'Hungary',
    nombre: 'Hungría ',
    iso: 'HU',
  },
  {
    name: 'Indonesia',
    nombre: 'Indonesia ',
    iso: 'ID',
  },
  {
    name: 'Ireland',
    nombre: 'Irlanda ',
    iso: 'IE',
  },
  {
    name: 'Israel',
    nombre: 'Israel ',
    iso: 'IL',
  },
  {
    name: 'India',
    nombre: 'India ',
    iso: 'IN',
  },
  {
    name: 'British Indian Ocean Territory',
    nombre: 'Territorio Británico del Océano Índico',
    iso: 'IO',
  },
  {
    name: 'Iraq',
    nombre: 'Irak ',
    iso: 'IQ',
  },
  {
    name: 'Iran',
    nombre: 'Irán ',
    iso: 'IR',
  },
  {
    name: 'Iceland',
    nombre: 'Islandia ',
    iso: 'IS',
  },
  {
    name: 'Italy',
    nombre: 'Italia ',
    iso: 'IT',
  },
  {
    name: 'Jamaica',
    nombre: 'Jamaica ',
    iso: 'JM',
  },
  {
    name: 'Jordan',
    nombre: 'Jordania ',
    iso: 'JO',
  },
  {
    name: 'Japan',
    nombre: 'Japón ',
    iso: 'JP',
  },
  {
    name: 'Kenya',
    nombre: 'Kenia ',
    iso: 'KE',
  },
  {
    name: 'Kyrgyzstan',
    nombre: 'Kirguistán ',
    iso: 'KG',
  },
  {
    name: 'Cambodia',
    nombre: 'Camboya ',
    iso: 'KH',
  },
  {
    name: 'Kiribati',
    nombre: 'Kiribati ',
    iso: 'KI',
  },
  {
    name: 'Comoros',
    nombre: 'Comoras ',
    iso: 'KM',
  },
  {
    name: 'Saint Kitts and Nevis',
    nombre: 'Saint Kitts y Nevis ',
    iso: 'KN',
  },
  {
    name: 'Korea North',
    nombre: 'Corea del Norte ',
    iso: 'KP',
  },
  {
    name: 'Korea South',
    nombre: 'Corea del Sur ',
    iso: 'KR',
  },
  {
    name: 'Kuwait',
    nombre: 'Kuwait ',
    iso: 'KW',
  },
  {
    name: 'Cayman Islands',
    nombre: 'Las Islas Caimán ',
    iso: 'KY',
  },
  {
    name: 'Kazakhstan',
    nombre: 'Kazajstán ',
    iso: 'KZ',
  },
  {
    name: 'Laos',
    nombre: 'Laos ',
    iso: 'LA',
  },
  {
    name: 'Lebanon',
    nombre: 'Líbano ',
    iso: 'LB',
  },
  {
    name: 'Saint Lucia',
    nombre: 'Santa Lucía ',
    iso: 'LC',
  },
  {
    name: 'Liechtenstein',
    nombre: 'Liechtenstein ',
    iso: 'LI',
  },
  {
    name: 'Sri Lanka',
    nombre: 'Sri Lanka ',
    iso: 'LK',
  },
  {
    name: 'Liberia',
    nombre: 'Liberia ',
    iso: 'LR',
  },
  {
    name: 'Lesotho',
    nombre: 'Lesoto ',
    iso: 'LS',
  },
  {
    name: 'Lithuania',
    nombre: 'Lituania ',
    iso: 'LT',
  },
  {
    name: 'Luxembourg',
    nombre: 'Luxemburgo ',
    iso: 'LU',
  },
  {
    name: 'Latvia',
    nombre: 'Letonia ',
    iso: 'LV',
  },
  {
    name: 'Libya',
    nombre: 'Libia ',
    iso: 'LY',
  },
  {
    name: 'Morocco',
    nombre: 'Marruecos ',
    iso: 'MA',
  },
  {
    name: 'Monaco',
    nombre: 'Mónaco ',
    iso: 'MC',
  },
  {
    name: 'Moldova',
    nombre: 'Moldavia ',
    iso: 'MD',
  },
  {
    name: 'Madagascar',
    nombre: 'Madagascar ',
    iso: 'MG',
  },
  {
    name: 'Marshall Islands',
    nombre: 'Islas Marshall ',
    iso: 'MH',
  },
  {
    name: 'Macedonia',
    nombre: 'Macedonia ',
    iso: 'MK',
  },
  {
    name: 'Mali',
    nombre: 'Malí ',
    iso: 'ML',
  },
  {
    name: 'Myanmar',
    nombre: 'Myanmar ',
    iso: 'MM',
  },
  {
    name: 'Mongolia',
    nombre: 'Mongolia ',
    iso: 'MN',
  },
  {
    name: 'Macau',
    nombre: 'Macao ',
    iso: 'MO',
  },
  {
    name: 'Northern Mariana Islands',
    nombre: 'Islas Marianas del Norte ',
    iso: 'MP',
  },
  {
    name: 'Martinique',
    nombre: 'Martinica ',
    iso: 'MQ',
  },
  {
    name: 'Mauritania',
    nombre: 'Mauritania ',
    iso: 'MR',
  },
  {
    name: 'Montserrat',
    nombre: 'Montserrat ',
    iso: 'MS',
  },
  {
    name: 'Malta',
    nombre: 'Malta ',
    iso: 'MT',
  },
  {
    name: 'Mauritius',
    nombre: 'Mauricio ',
    iso: 'MU',
  },
  {
    name: 'Maldives',
    nombre: 'Maldivas ',
    iso: 'MV',
  },
  {
    name: 'Malawi',
    nombre: 'Malawi ',
    iso: 'MW',
  },
  {
    name: 'Mexico',
    nombre: 'México ',
    iso: 'MX',
  },
  {
    name: 'Malaysia',
    nombre: 'Malasia ',
    iso: 'MY',
  },
  {
    name: 'Mozambique',
    nombre: 'Mozambique ',
    iso: 'MZ',
  },
  {
    name: 'Namibia',
    nombre: 'Namibia ',
    iso: 'NA',
  },
  {
    name: 'New Caledonia',
    nombre: 'Nueva Caledonia ',
    iso: 'NC',
  },
  {
    name: 'Niger',
    nombre: 'Níger ',
    iso: 'NE',
  },
  {
    name: 'Norfolk Island',
    nombre: 'Norfolk Island ',
    iso: 'NF',
  },
  {
    name: 'Nigeria',
    nombre: 'Nigeria ',
    iso: 'NG',
  },
  {
    name: 'Nicaragua',
    nombre: 'Nicaragua ',
    iso: 'NI',
  },
  {
    name: 'Netherlands',
    nombre: 'Países Bajos ',
    iso: 'NE',
  },
  {
    name: 'Norway',
    nombre: 'Noruega ',
    iso: 'NO',
  },
  {
    name: 'Nepal',
    nombre: 'Nepal ',
    iso: 'NP',
  },
  {
    name: 'Nauru',
    nombre: 'Nauru ',
    iso: 'NR',
  },
  {
    name: 'Niue',
    nombre: 'Niue ',
    iso: 'NU',
  },
  {
    name: 'New Zealand',
    nombre: 'Nueva Zelanda ',
    iso: 'NZ',
  },
  {
    name: 'Oman',
    nombre: 'Omán ',
    iso: 'OM',
  },
  {
    name: 'Panama',
    nombre: 'Panamá ',
    iso: 'PA',
  },
  {
    name: 'Peru',
    nombre: 'Perú ',
    iso: 'PE',
  },
  {
    name: 'French Polynesia',
    nombre: 'Polinesia francés ',
    iso: 'PF',
  },
  {
    name: 'Papua New Guinea',
    nombre: 'Papua Nueva Guinea ',
    iso: 'PG',
  },
  {
    name: 'Philippines',
    nombre: 'Filipinas ',
    iso: 'PH',
  },
  {
    name: 'Pakistan',
    nombre: 'Pakistán ',
    iso: 'PK',
  },
  {
    name: 'Poland',
    nombre: 'Polonia ',
    iso: 'PO',
  },
  {
    name: 'St. Pierre and Miquelon',
    nombre: 'San Pedro y Miquelón ',
    iso: 'PM',
  },
  {
    name: 'Pitcairn',
    nombre: 'Pitcairn ',
    iso: 'PN',
  },
  {
    name: 'Puerto Rico',
    nombre: 'Puerto Rico ',
    iso: 'PR',
  },
  {
    name: 'Portugal',
    nombre: 'Portugal ',
    iso: 'PT',
  },
  {
    name: 'Palau',
    nombre: 'Palau ',
    iso: 'PW',
  },
  {
    name: 'Paraguay',
    nombre: 'Paraguay ',
    iso: 'PY',
  },
  {
    name: 'Qatar',
    nombre: 'Qatar ',
    iso: 'QA',
  },
  {
    name: 'Reunion',
    nombre: 'Reunión ',
    iso: 'RE',
  },
  {
    name: 'Romania',
    nombre: 'Rumania ',
    iso: 'RO',
  },
  {
    name: 'Russian Federation',
    nombre: 'La Federación de Rusia ',
    iso: 'RU',
  },
  {
    name: 'Rwanda',
    nombre: 'Ruanda ',
    iso: 'RW',
  },
  {
    name: 'Saudi Arabia',
    nombre: 'Arabia Saudita ',
    iso: 'SA',
  },
  {
    name: 'Solomon Islands',
    nombre: 'Las Islas Salomón ',
    iso: 'SB',
  },
  {
    name: 'Seychelles',
    nombre: 'Seychelles ',
    iso: 'SC',
  },
  {
    name: 'Sudan',
    nombre: 'Sudán ',
    iso: 'SD',
  },
  {
    name: 'Sweden',
    nombre: 'Suecia ',
    iso: 'SE',
  },
  {
    name: 'Singapore',
    nombre: 'Singapur ',
    iso: 'SG',
  },
  {
    name: 'St. Helena',
    nombre: 'Santa Elena ',
    iso: 'SH',
  },
  {
    name: 'Slovenia',
    nombre: 'Eslovenia ',
    iso: 'SI',
  },
  {
    name: 'Svalbard and Jan Mayen Islands',
    nombre: 'Svalbard y Jan Mayen ',
    iso: 'SJ',
  },
  {
    name: 'Slovak Republic',
    nombre: 'República Eslovaca ',
    iso: 'SK',
  },
  {
    name: 'Sierra Leone',
    nombre: 'Sierra Leona ',
    iso: 'SL',
  },
  {
    name: 'San Marino',
    nombre: 'San Marino ',
    iso: 'SM',
  },
  {
    name: 'Senegal',
    nombre: 'Senegal ',
    iso: 'SN',
  },
  {
    name: 'Somalia',
    nombre: 'Somalia ',
    iso: 'SO',
  },
  {
    name: 'Suriname',
    nombre: 'Suriname ',
    iso: 'SR',
  },
  {
    name: 'Sao Tome and Principe',
    nombre: 'Santo Tomé y Príncipe ',
    iso: 'ST',
  },
  {
    name: 'El Salvador',
    nombre: 'El Salvador ',
    iso: 'SV',
  },
  {
    name: 'Syria',
    nombre: 'Siria ',
    iso: 'SY',
  },
  {
    name: 'Swaziland',
    nombre: 'Swazilandia ',
    iso: 'SZ',
  },
  {
    name: 'Turks and Caicos Islands',
    nombre: 'Islas Turcas y Caicos ',
    iso: 'TC',
  },
  {
    name: 'Chad',
    nombre: 'Chad ',
    iso: 'TD',
  },
  {
    name: 'French Southern Territories',
    nombre: 'Territorios del sur francés ',
    iso: 'TF',
  },
  {
    name: 'Togo',
    nombre: 'Togo ',
    iso: 'TG',
  },
  {
    name: 'Thailand',
    nombre: 'Tailandia ',
    iso: 'TH',
  },
  {
    name: 'Tajikistan',
    nombre: 'Tayikistán ',
    iso: 'TI',
  },
  {
    name: 'Tokelau',
    nombre: 'Tokelau ',
    iso: 'TK',
  },
  {
    name: 'Turkmenistan',
    nombre: 'Turkmenistán ',
    iso: 'TM',
  },
  {
    name: 'Tunisia',
    nombre: 'Túnez ',
    iso: 'TN',
  },
  {
    name: 'Tonga',
    nombre: 'Tonga ',
    iso: 'TO',
  },
  {
    name: 'East Timor',
    nombre: 'Timor Oriental ',
    iso: 'TP',
  },
  {
    name: 'Turkey',
    nombre: 'Turquía ',
    iso: 'TR',
  },
  {
    name: 'Trinidad and Tobago',
    nombre: 'Trinidad y Tobago ',
    iso: 'TT',
  },
  {
    name: 'Tuvalu',
    nombre: 'Tuvalu ',
    iso: 'TV',
  },
  {
    name: 'Taiwan',
    nombre: 'Taiwan ',
    iso: 'TW',
  },
  {
    name: 'Tanzania',
    nombre: 'Tanzania ',
    iso: 'TZ',
  },
  {
    name: 'Ukraine',
    nombre: 'Ucrania ',
    iso: 'UA',
  },
  {
    name: 'Uganda',
    nombre: 'Uganda ',
    iso: 'UG',
  },
  {
    name: 'United Kingdom',
    nombre: 'Reino Unido ',
    iso: 'UK',
  },
  {
    name: 'US Minor Outlying Islands',
    nombre: 'Islas menores  de EE.UU.',
    iso: 'UM',
  },
  {
    name: 'United States of America (USA)',
    nombre: 'Estados Unidos de América (EE.UU.) ',
    iso: 'US',
  },
  {
    name: 'Uruguay',
    nombre: 'Uruguay ',
    iso: 'UY',
  },
  {
    name: 'Uzbekistan',
    nombre: 'Uzbekistán ',
    iso: 'UZ',
  },
  {
    name: 'Vatican City State',
    nombre: 'Ciudad del Vaticano ',
    iso: 'VA',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    nombre: 'San Vicente y las Granadinas ',
    iso: 'VC',
  },
  {
    name: 'Venezuela',
    nombre: 'Venezuela ',
    iso: 'VE',
  },
  {
    name: 'Virgin Islands (British)',
    nombre: 'Islas Vírgenes (Británicas) ',
    iso: 'VG',
  },
  {
    name: 'Viet Nam',
    nombre: 'Vietnam ',
    iso: 'VN',
  },
  {
    name: 'Vanuatu',
    nombre: 'Vanuatu ',
    iso: 'VU',
  },
  {
    name: 'Wallis and Futuna Islands',
    nombre: 'Islas Wallis y Futuna ',
    iso: 'WF',
  },
  {
    name: 'Samoa',
    nombre: 'Samoa ',
    iso: 'WS',
  },
  {
    name: 'Yemen',
    nombre: 'Yemen ',
    iso: 'YE',
  },
  {
    name: 'Mayotte',
    nombre: 'Mayotte ',
    iso: 'YT',
  },
  {
    name: 'Yugoslavia',
    nombre: 'Yugoslavia ',
    iso: 'YU',
  },
  {
    name: 'South Africa',
    nombre: 'Sudáfrica ',
    iso: 'ZA',
  },
  {
    name: 'Zambia',
    nombre: 'Zambia ',
    iso: 'ZM',
  },
  {
    name: 'Zaire',
    nombre: 'Zaire ',
    iso: 'ZR',
  },
  {
    name: 'Zimbabwe',
    nombre: 'Zimbabue ',
    iso: 'ZW',
  },
];
export const COUNTRIES_CODE = COUNTRIES.map((country) => country.iso);

export const COLORS = [
  '#004e78',
  '#13dfb6',
  '#df8f13',
  '#df1351',
  '#006400',
  '#b35700',
  '#8B0000',
  '#6a0dad',
  '#0077a1',
  '#003257',
  '#1be2c2',
  '#0a9f8b',
  '#ff7a3d',
  '#d94f1e',
  '#e55675',
  '#b71c3b',
  '#338033',
  '#004d00',
  '#d67a2b',
  '#9a4500',
  '#b80000',
  '#660000',
  '#9b34d3',
  '#550b92',
];

export const splitZipName = (zip_data: string) =>
  zip_data.split('-').length > 3
    ? zip_data.split('-').slice(5).join('-')
    : zip_data;
